import script from "./Noticia.vue?vue&type=script&setup=true&lang=js"
export * from "./Noticia.vue?vue&type=script&setup=true&lang=js"

import "./Noticia.vue?vue&type=style&index=0&id=1c9140bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9140bc"]])

export default __exports__